import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/**
 * Floating "back to top" button — fixed bottom-right.
 * Fades in after 400 px of scroll; smooth-scrolls to top on click.
 * Mounted once at the app root so every page inherits it.
 */
export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={scrollTop}
      aria-label="Back to top"
      data-testid="back-to-top"
      className={
        "fixed bottom-6 right-6 z-40 h-11 w-11 rounded-full flex items-center justify-center " +
        "shadow-lg transition-all duration-300 ease-out " +
        (visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-4 pointer-events-none")
      }
      style={{ background: "#4CAF50", color: "white" }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#43a047")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "#4CAF50")}
    >
      <ArrowUp className="h-5 w-5" strokeWidth={2.5} />
    </button>
  );
}
